// REST client for a visitor's page-visit timeline.

import type { VisitorId } from '@prakash-software/shared';
import { apiFetch } from './api';
import type { PageVisit } from '../stores/page-visits';

/** Fetch the persisted page timeline for a visitor (most recent first). */
export async function fetchPageVisits(visitorId: VisitorId): Promise<PageVisit[]> {
  const res = await apiFetch<{ pages: PageVisit[] }>(
    `/api/visitors/${encodeURIComponent(visitorId)}/pages`,
  );
  return res.pages ?? [];
}
